
import React from 'react';
import { Card } from '@dhis2/ui';

const MetricCard = ({ title, value, subtitle, color = '#007bff' }) => {
  // Generate background color based on the card's color prop
  const getBackgroundColor = (cardColor) => {
    const alpha = cardColor.length === 9 ? cardColor.slice(-2) : '30'; // Use existing alpha or default to 30
    const hex = cardColor.length === 9 ? cardColor.slice(0, 7) : cardColor;
    return `${hex}${alpha}`;
  };

  // Generate shadow based on the card's color
  const getShadow = (cardColor) => {
    // Convert hex to RGB for shadow
    const hex = cardColor.length === 9 ? cardColor.slice(0, 7) : cardColor;
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `0 8px 24px rgba(${r}, ${g}, ${b}, 0.18)`;
  };

  // Generate lighter border color for better contrast
  const getBorderColor = (cardColor) => {
    const hex = cardColor.length === 9 ? cardColor.slice(0, 7) : cardColor;
    return `${hex}80`; // 50% opacity
  };

  return (
    <Card 
      style={{ 
        padding: '24px', 
        textAlign: 'center', 
        height: '100%',
        borderLeft: `6px solid ${getBorderColor(color)}`,
        boxShadow: getShadow(color),
        background: `${color}15`, // 10% opacity background
        borderRadius: '12px',
        transition: 'all 0.3s ease',
        position: 'relative',
        overflow: 'hidden',        
      }}
    >
      {/* Subtle gradient overlay */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '4px',
        background: `linear-gradient(90deg, transparent, ${color}40, transparent)`,
        opacity: 0.7, 
      }} />
      
      <div style={{ 
        position: 'relative',
        zIndex: 1
      }}>
        <div style={{ 
          fontSize: '36px', 
          fontWeight: '700', 
          color: color, 
          marginBottom: '12px',
          textShadow: '0 2px 4px rgba(0,0,0,0.1)',
          marginLeft: '10px', 
        }}>
          {value}
        </div>
        
        <div style={{ 
          fontSize: '16px', 
          fontWeight: '600', 
          color: '#343a40', 
          marginBottom: '8px',
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
          marginLeft: '10px', 
        }}>
          {title}
        </div>
        
        {subtitle && (
          <div style={{ 
            fontSize: '13px', 
            color: '#6c757d',
            lineHeight: 1.4,
            fontWeight: '500',
            marginLeft: '10px', 
          }}>
            {subtitle}
          </div>
        )}
      </div>
    </Card>
  );
};

export default MetricCard;
